import React from "react";
import "./css/Studio.css";
import { FiMapPin, FiPhone } from "react-icons/fi";
import { useState } from "react";

function Studio() {
  // Top images from 1 to 17
  const [selectedImage, setSelectedImage] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleCopy = (number) => {
    navigator.clipboard.writeText(number).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
    });
  };
  function shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
  const studioImages = shuffleArray(
    Array.from({ length: 13 }, (_, i) => `/assets/studio/${i + 1}.jpg`)
  );

  const verticalImages = shuffleArray(
    Array.from({ length: 3 }, (_, i) => `/assets/studio/vertical/${i + 1}.jpg`)
  );

  return (
    <div className="studio-wrapper">
      <header className="studio-header">
        <h2 className="studio-title">Hxabyte Records Studio</h2>
        <div className="studio-subtitle">
          <p></p> Crafting sounds that move the world{" "}
          <a
            className="studio-map-icon"
            href="https://maps.app.goo.gl/gbCZL2nC8XZK5B8H8"
            target="_blank"
            rel="noopener noreferrer"
            title="Open in Google Maps"
          >
            Location <FiMapPin />
          </a>
        </div>
        <p className="studio-description">
          <strong>HXABYTE RECORDS</strong> is a comprehensive audio production
          studio offering <em>recording</em>,<em> dubbing</em>,{" "}
          <em>composing</em>, <em>mixing</em>, and <em>mastering</em> services,
          based in Salem, India. It is also a certified{" "}
          <strong>Dolby Atmos Studio</strong> and <strong>Theatre</strong>{" "}
          delivering immersive sound experiences.
        </p>{" "}
      </header>

      <section className="studio-gallery">
        {studioImages.map((src, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => setSelectedImage(src)}
          >
            <img
              src={src}
              alt={`Studio Image ${index + 1}`}
              className="gallery-img"
            />
          </div>
        ))}
      </section>
      <section className="vertical-gallery">
        <h2 className="vertical-title">In-Studio Moments</h2>
        <div className="vertical-grid">
          {verticalImages.map((src, index) => (
            <div
              className="vertical-item"
              key={index}
              onClick={() => setSelectedImage(src)}
            >
              <img
                src={src}
                alt={`Vertical ${index + 1}`}
                className="vertical-img"
              />
            </div>
          ))}
        </div>
      </section>
      <section
        className="studio-scroll-parallax"
        style={{
          backgroundImage: `url("/assets/studio/vertical/2.jpg")`,
        }}
      >
        <h2 className="parallax-text">Record. Produce. Release.</h2>
      </section>
      <p className="studio-address">
        172/7, Annai Thresa Nagar, Convent Road, New Fairlands, Salem 636016,
        Tamil Nadu, India
        <a
          className="studio-map-icon"
          href="https://maps.app.goo.gl/gbCZL2nC8XZK5B8H8"
          target="_blank"
          rel="noopener noreferrer"
          title="Open in Google Maps"
        >
          Location <FiMapPin />
        </a>
        <br />
        <a href="tel:+918248306704" className="studio-contact">
          <FiPhone />
          <br />
          +91 8248306704
        </a>
        <button
          className="copy-btn"
          onClick={() => handleCopy("+918248306704")}
        >
          {copied ? "Copied!" : "Copy"}
        </button>
      </p>
      {selectedImage && (
        <div
          className="studio-image-modal"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Preview"
            className="studio-modal-image"
          />
          <button
            className="studio-close-button"
            onClick={() => setSelectedImage(null)}
          >
            ✖
          </button>
        </div>
      )}
    </div>
  );
}

export default Studio;
